var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page page-on-center close-picker rowBackgroundHomepage",
      attrs: { id: "inbox", "data-page": "inbox-page" },
      on: {
        "ptr:refresh": function ($event) {
          return _vm.refreshDocumentDetails(false)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "showSmallScreenOnly blackBottomButton" },
        [
          _c(
            "f7-fab",
            {
              staticClass:
                "leftfav button-fab bottomButton floatingButtonToolbarBlank",
              on: {
                click: function ($event) {
                  return _vm.extractCSV(_vm.documentsList)
                },
              },
            },
            [_c("f7-icon", { attrs: { f7: "document_text" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "page-content infinite-scroll",
          staticStyle: { "z-index": "9" },
        },
        [
          _c("div", { staticClass: "listPage" }, [
            _c("div", { staticClass: "row showLargeScreenOnly" }, [
              _c(
                "div",
                { staticClass: "row rowSearchBar" },
                [
                  _c("back-button", { staticClass: "firstBlock" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "milkyBlockBlack new-button-white firstBlock pull-right",
                      on: {
                        click: function ($event) {
                          return _vm.extractCSV(_vm.documentsList)
                        },
                      },
                    },
                    [
                      _c("f7-icon", { attrs: { f7: "document_text" } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "fab-label" }, [
                        _vm._v(_vm._s(_vm.$t("common.extract_csv"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "milkyBlockBlack firstBlock new-button-white",
                      on: {
                        click: function ($event) {
                          return _vm.refreshDocumentDetails()
                        },
                      },
                    },
                    [
                      _c("f7-icon", { attrs: { f7: "refresh" } }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "showLargeScreenOnly fab-label" },
                        [
                          _vm._v(
                            "\r\n              " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\r\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "searchForm col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "requestsList" },
                  [
                    _c("cm-messages-filter", {
                      staticClass: "researchfilter",
                      staticStyle: { position: "relative", "z-index": "10" },
                      attrs: {
                        isPayments: true,
                        received: true,
                        listMainTitle: _vm.currentFolder[0].reference,
                        filterType: "details",
                      },
                      on: {
                        applyFilter: function ($event) {
                          return _vm.applyFilter($event)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "f7-accordion-item",
                      {
                        staticClass: "accordionForm",
                        attrs: { expanded: true },
                      },
                      [
                        _c(
                          "f7-accordion-toggle",
                          { staticClass: "accordionToggle" },
                          [
                            _c("transactions-list", {
                              staticStyle: { "border-radius": "0" },
                              attrs: {
                                filterBy: false,
                                messages: _vm.currentFolder,
                                serviceId: _vm.serviceId,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "f7-accordion-content",
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _vm.detailsDone
                              ? _c("documents-list", {
                                  attrs: {
                                    filterBy: false,
                                    documents: _vm.documentsList,
                                  },
                                  on: {
                                    "get-folder-info": function ($event) {
                                      return _vm.getFolderInfo()
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-start" }, [
              _c("div", { staticClass: "col-md-3 offset-md-9" }, [
                _vm.currentFolder[0].status !== "31"
                  ? _c(
                      "button",
                      {
                        staticClass: "button-action milkyBlockBlack",
                        attrs: { round: "" },
                        on: {
                          click: function ($event) {
                            return _vm.updateFolderStatus("31")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "icon fa fa-check" }),
                        _vm._v(
                          "\r\n            " +
                            _vm._s(
                              _vm.$t("businessDocuments.close_doc_group")
                            ) +
                            "\r\n          "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "button-action milkyBlockBlack",
                        attrs: { round: "" },
                        on: {
                          click: function ($event) {
                            return _vm.updateFolderStatus("30")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "icon fa fa-exclamation-circle",
                        }),
                        _vm._v(
                          "\r\n            " +
                            _vm._s(
                              _vm.$t("businessDocuments.reopen_doc_group")
                            ) +
                            "\r\n          "
                        ),
                      ]
                    ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "toolbarPageBottomBlank" }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }